<div class="lato mb-3" style="font-size: 0.875rem" *ngIf="showText">
  Signed Terms & Policies are required to attend Camp.
</div>
<ng-container *ngIf="!!helloSignService.requiredTermPolicyForm">
  <app-content-header [text]="termPolicyFormCountry + ' Terms & Policies'"></app-content-header>
  <div class="row no-gutters mt-3">
    <div class="col col-sm-9"   [class.m-auto]="!showText">
      <button
        type="button"
        class="btn btn-outline-danger btn-block mb-4"
        [disabled]="helloSignService.inCheckingSigningStatus"
        (click)="handleButtonClick()"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</ng-container>
